import * as React from 'react';
import moment from 'moment';
import { CompanyNodeEdge } from '../master/Company/constants';
import { Table, Spin, Button, Col, Divider, Row } from 'antd';
import { GraphqlQuery } from 'requestapijs';
import { ProductDetailsNodeConnection } from '../../schema';
import { Pagination } from 'sha-el-design';
import { downloadToFile } from '../helper';
import { BranchNodeEdge } from '../master/Branch/constants';
import { ITEM_WISE_APPROVAL_REPORT_CSV } from '../../config';
import { TSInput } from '../common/TSInput';
import { approvalReportQuery } from './constants';

export class ApprovalReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      after: '',
      currentPage: 1,
    };
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const nextState = { ...this.state };
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };

  columns = () => [
    {
      title: 'Approval No.',
      key: 'approvalNo',
      dataIndex: 'node.approvalNewProductDetails.edges[0].node.approvalNo',
    },
    {
      title: 'Approval Date',
      key: 'approvalDate',
      dataIndex: 'node.approvalNewProductDetails.edges[0].node.date',
    },
    {
      title: 'Approved by',
      key: 'approvalBy',
      dataIndex: 'node.approvalNewProductDetails.edges[0].node',
      render: (data) =>
        data ? `${data?.approvedByName} (${data?.approvedByDesignation}) ` : '',
    },
    {
      title: 'Approved to',
      key: 'approvalTo',
      dataIndex: 'node.approvalNewProductDetails.edges[0].node.customer.name',
    },
    {
      title: 'Product Name',
      key: 'product',
      dataIndex: 'node.product.name',
    },
    {
      title: 'Barcode 1',
      key: 'oldBarcode',
      dataIndex: 'node.product.oldBarcodeId',
    },
    {
      title: 'Barcode 2',
      key: 'newBarcode',
      dataIndex: 'node.product.newBarcodeId',
    },
    {
      title: 'Category',
      key: 'category',
      dataIndex: 'node.product.category.name',
    },
    {
      title: 'Division',
      key: 'division',
      dataIndex: 'node.product.division',
    },
    {
      title: 'Quantity',
      key: 'quantity',
      dataIndex: 'node.quantity',
    },
    {
      title: 'Rate',
      key: 'rate',
      dataIndex: 'node.rate',
    },
    {
      title: 'Approval Amount',
      key: 'amount',
      dataIndex: 'node.amount',
    },
    {
      title: 'Return For',
      key: 'returnFor',
      dataIndex:
        'node.approvalNewProductDetails.edges[0].node.oldApproval.approvalNo',
    },
  ];

  downloadCsv = () => {
    let queryParams = `companyId=${this.props.company.id}`;
    queryParams +=
      this.props.branch?.type === 'branch'
        ? `&branchId=${this.props.branch?.id}`
        : '';

    fetch(ITEM_WISE_APPROVAL_REPORT_CSV + '?' + queryParams)
      .then((value) => value.text())
      .then((v) =>
        downloadToFile(
          v,
          `item-wise-approval-report-${
            this.props.branch?.name
          }-${new Date().toISOString()}`,
          'ITEM WISE APPROVAL REPORT',
          this.props.company.name,
          this.props.branch?.name || '',
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY'),
          '',
        ),
      );
  };

  afterStack = [''];

  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  render() {
    const {
      company: { id: companyId },
    } = this.props;
    const branchId =
      this.props.branch?.type === 'branch' ? this.props.branch?.id : null;
    const isHeadOffice = !(this.props.branch?.type === 'branch');
    const { after, currentPage } = this.state;
    const variables = { companyId, branchId, after, isHeadOffice };
    return (
      <div>
        <Row>
          <Col span={5}>
            <TSInput
              error=""
              addonBefore="Date"
              value={moment().format('YYYY-MM-DD')}
            />
          </Col>
          <Col span={7}>
            <TSInput
              error=""
              addonBefore="Location"
              value={this.props.branch?.name || 'Head Office'}
            />
          </Col>
        </Row>
        <Divider />
        <GraphqlQuery
          queryString={approvalReportQuery}
          variables={variables}
          render={(
            response: { allProductDetails: ProductDetailsNodeConnection },
            error,
            loading,
          ) => {
            if (loading) return <Spin />;
            if (error) return <h3>Something Went Wrong!!</h3>;
            if (response) {
              return [
                <Table
                  dataSource={response.allProductDetails.edges}
                  columns={this.columns()}
                  key="Table"
                  pagination={false}
                  rowKey="node.id"
                  scroll={{ x: true }}
                />,
                <Pagination
                  key="Pagination"
                  totalCount={0}
                  cursorBasedPagination
                  currentPage={currentPage}
                  batchSize={20}
                  onChange={(_p, _ps, next) =>
                    this.onPageChange(
                      next,
                      response.allProductDetails.pageInfo.endCursor,
                      response.allProductDetails.pageInfo.hasNextPage,
                    )
                  }
                  style={{ float: 'right' }}
                />,
                <Button
                  style={{ float: 'right' }}
                  icon="download"
                  onClick={() => this.downloadCsv()}
                  key="button"
                />,
              ];
            }
          }}
        />
      </div>
    );
  }
}

interface Props {
  company: CompanyNodeEdge;
  branch: BranchNodeEdge | null;
}

interface State {
  after: string;
  currentPage: number;
}
